// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1":"b86d70f0","392":"14e01f2a","489":"516f2fbf","687":"43bcd81e","784":"c6f9a5c1","941":"d7413e9c"}[chunkId] + ".css";
};